﻿﻿﻿<h2>Remote Reset commands for selected Controller Type</h2>
<remoteresetcommand-list [list]="list" (onReload)="onReload($event)"></remoteresetcommand-list>